// LEGACY: Used fpr CK preview and export
// TODO: Remove this once we migrated all the CK links
import Vue from 'vue';
import { defineStore } from 'pinia';
import { convertBase64ToBlob } from '@/services/utils/file-utils';

export const useCkeditorStore = defineStore('ckeditor', {
    state: () => ({
        ckeditorHtml: null,
    }),

    actions: {
        /**
         * Backward compatibility prepare html data for ck based files to view in superdoc
         * @param htmlData
         * @param hiddenInputs
         * @param annotationProcessing
         * @param deleteHiddenAnnotations
         * @returns {string}
         */
        prepareHtmlData(
            htmlData,
            hiddenInputs,
            annotationProcessing = null,
            deleteHiddenAnnotations = false,
        ) {
            const wrapper = document.createElement('div');
            wrapper.innerHTML = htmlData;
            const annotations = wrapper.querySelectorAll('.annotation');

            let hiddenAnnotationHandler = null;
            if (deleteHiddenAnnotations) {
                hiddenAnnotationHandler = (annotation) => annotation.remove();
            } else {
                hiddenAnnotationHandler = (annotation) => (annotation.style.display = 'none');
            }

            const hiddenAnnotations = Array.from(annotations).filter((annotation) => {
                const { itemid } = annotation.dataset;
                const hidden = hiddenInputs[itemid];
                if (hidden) {
                    return annotation;
                } else if (!annotationProcessing) {
                    annotation.style.removeProperty('display');
                }
            });
            hiddenAnnotations.forEach(hiddenAnnotationHandler);

            // additional in-place processing of annotations
            if (annotationProcessing) {
                annotationProcessing(annotations);
            }

            const resultHtml = wrapper.innerHTML;
            wrapper.remove();
            return resultHtml;
        },

        /**
         * @param {string} templateId - The ID of the template
         * @param {string} linkId - The ID of the link
         * @returns {Promise<string>} The CKEditor HTML
         */
        async getCKTemplateHtml(templateId, linkId = null) {
            const res = await Vue.prototype.$harbourData.post('/data?template_ckeditor_html', {
                requesttype: 'template_ckeditor_html',
                templateId,
                linkid: linkId
            });
            console.log("getCKTemplateHtml", res.data);
            if (res.data.html) {
                console.log("getCKTemplateHtml", res.data.html);
                return res.data.html;
            }
            console.log("getCKTemplateHtml", null);
            return null;
        },

        /**
         * @param {string} fileName - The name of the file
         * @param {string} linkId - The ID of the link
         * @returns {Promise<File>} The PDF file
         */
        async exportCKAsPDF(fileName, linkId) {
            const res = await Vue.prototype.$harbourData.post('/data?export_ck_as_pdf', {
                requesttype: 'export_ck_as_pdf',
                link_id: linkId
            });
            const pdfBlob = convertBase64ToBlob(res.data.pdf_base64, 'application/pdf');
            return new File([pdfBlob], `${fileName}.pdf`, { type: 'application/pdf' });
        }
    }
});
